var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.getStatusCSS(_vm.data.item)},[_vm._v(" "+_vm._s(_vm.getStatus(_vm.data.item))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }